export const CommercialTierEnum = Object.freeze({
    0: 'UNCONTRACTED',
    1: 'TIER_1',
    2: 'TIER_2',
    3: 'TIER_3'
});

export const AdviserCommercialTierEnum = Object.freeze({
    0: 'UNCONTRACTED',
    1: 'TIER_1',
    2: 'TIER_2'
});

export default CommercialTierEnum;
